import { render, staticRenderFns } from "./WeeklyAbout.vue?vue&type=template&id=76e498a4&"
import script from "./WeeklyAbout.vue?vue&type=script&lang=js&"
export * from "./WeeklyAbout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports